// extracted by mini-css-extract-plugin
export default {"delivery":"Cvw56","inner":"nJcdP ZdH1P","title":"EKGqe","text":"U_I3g","link":"LbKuT","more":"Y_qnF","image":"Go3xz"};